import { render, staticRenderFns } from "./PaamieshallintaSelaa.vue?vue&type=template&id=228b79cf&scoped=true&"
import script from "./PaamieshallintaSelaa.vue?vue&type=script&lang=js&"
export * from "./PaamieshallintaSelaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b79cf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VDataTable,VProgressLinear,VSpacer,VToolbar,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228b79cf')) {
      api.createRecord('228b79cf', component.options)
    } else {
      api.reload('228b79cf', component.options)
    }
    module.hot.accept("./PaamieshallintaSelaa.vue?vue&type=template&id=228b79cf&scoped=true&", function () {
      api.rerender('228b79cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PaamieshallintaSelaa.vue"
export default component.exports